export default "__VITE_ASSET__C86kH_xn__"